import { createSelector } from '@ngrx/store';
import { selectPatientsState } from '@patients-store/reducers';
import { PatientAlertStateMap } from '@patients-store/reducers/patient-alert.reducer';

export const selectPatientAlertState =
	createSelector(selectPatientsState, state => state.patientAlertState);

export const selectPatientAlerts = (props: {patientId: number}) =>
	createSelector(selectPatientAlertState, (state: PatientAlertStateMap) => state.get(props.patientId));
